import styled from 'styled-components';
import like from './like.svg';
import start from './start.svg';

const Shape = ({ style, type }) => {
  return (
    <Wrapper style={style}>
      {type === 'like' ? (
        <img src={like} alt="like" style={{ width: '100%' }} />
      ) : (
        <img src={start} alt="start" style={{ width: '100%' }} />
      )}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  z-index: -1;
  position: absolute;
  animation: boundInDown 1s ease forwards;

  @keyframes boundInDown {
    0% {
      opacity: 0;
      top: -500px;
      bottom: -500px;
    }
    100% {
      opacity: 1;
    }
  }
`;

export default Shape;
